function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ACTIONS_STATE_NAME } from './components/customer/demoActions/demoActions.config';
import { STATE_OR_NAME as E_WALLET_PAGE } from './components/customer/ewallet/ewallet.config';
import { OFFERINGS_STATE_NAME } from './components/customer/offerings/offerings.config';
import { DISCONNECT_CUSTOMER_DBSS_ROUTE, DISCONNECT_OFFERS_DBSS_ROUTE } from './components/customer/offers/disconnect/dbss/disconnect.offers.dbss.config';
import { ORDER_HISTORY_DETAILS_STATE_NAME, ORDER_HISTORY_LIST_STATE_NAME } from './components/customer/orderHistory/order.history.config';
import { GROUP_ORDER_HISTORY_LIST_STATE_NAME } from './components/customer/orderHistory/orderHistoryListWrapper/order.history.list.wrapper.config';
import { TRANSFER_STATE_NAME } from './components/customer/orders/transfer/transfer.wizard.config';
import { REVIEW_STORE_ORDER_TRANSITION } from './components/customer/orders/transition/transition.offer.wizard.constants';
import { DETAIL_STATE_OR_NAME as PRODUCT_DETAILS_PAGE_REDIRECT } from './components/customer/products/products.config';
import { SERVICE_DETAILS_STATE_NAME } from './components/customer/servicesAndUsage/services.and.usage.config';
import { SERVICE_USAGE_DETAILS_STATE_NAME } from './components/customer/servicesAndUsage/usageDetails/usage.details.config';
import { ADD_OFFERING_INSTANCES, STATE_OR_NAME as ADD_OFFERING_PAGE, REVIEW_SAVED_CART, REVIEW_SAVED_CART_INSTANCES, REVIEW_STORE_ORDER_ADD } from './reducers/constants/add.offer.wizard.constants';
import { DASHBOARD_ROUTE } from './reducers/constants/dashboard.constants';
import { EDIT_OFFERING_INSTANCES, STATE_OR_NAME as EDIT_OFFERING_PAGE, RECONNECT_OFFER_STATE_NAME, REVIEW_STORE_ORDER_EDIT } from './reducers/constants/edit.offer.wizard.constants';
import { GUEST_CHECKOUT, STATE_OR_NAME as NEW_CONNECT_PAGE } from './reducers/constants/new.connect.wizard.constants';
import { CREATE_PRODUCTS_ORDER_STATE_NAME } from './reducers/constants/products.wizard.constants';
import { STATE_OR_NAME as CHANGE_OFFERING_PAGE } from './reducers/constants/transition.offer.wizard.constants';
var CUSTOMER = '/customer/:customerId';
var ORDERING = "".concat(CUSTOMER, "/ordering");
export var HOME = '/';
export var SERVICES_AND_USAGES = "".concat(CUSTOMER, "/services-and-usages");
export var SERVICES = "".concat(SERVICES_AND_USAGES, "/services");
var ADDRESSES_STATE_REDIRECT = 'index.customercare.customer.addresses';
var RATE_SHEET_STATE_REDIRECT = 'index.customercare.customer.agreement';
var ACCOUNT_HIERARCHY_STATE_REDIRECT = 'index.customercare.customer.accountHierarchyRedirect';
export var ACCOUNT_HIERARCHY_NODE_SERVICES_PAGE_REDIRECT = 'index.customercare.customer.accountHierarchyNodeServicesRedirect';
export var E_WALLET_STATE_REDIRECT = 'index.customercare.customer.eWalletRedirect';
export var PROFILE_PAGE_REDIRECT = 'index.customercare.customer.profile';
export var CASES_LIST_STATE_REDIRECT = 'index.customercare.customer.casesRedirect';
export var RETRY_ACTIVATION_PAYMENT_STATE_REDIRECT = 'index.customercare.customer.retryActivationPaymentRedirect';
export var CASES_DETAILS_STATE_REDIRECT = 'index.customercare.customer.cases.detailsRedirect';
var INVOICE_MESSAGES_LIST_STATE_REDIRECT = 'index.customercare.customer.invoiceMessagesRedirect';
var INVENTORY_LIST_STATE_REDIRECT = 'index.customercare.customer.inventory';
var INTERACTIONS_LIST_STATE_REDIRECT = 'index.customercare.customer.interactionsRedirect';
var INTERACTIONS_DETAILS_STATE_REDIRECT = 'index.customercare.customer.interactions.detailRedirect';
var NOTIFICATIONS_LIST_STATE_REDIRECT = 'index.customercare.customer.notificationsRedirect';
export var INVENTORY_DETAILS_STATE_REDIRECT = 'index.customercare.customer.inventoryDetails';
export var PRICING_PLAN_EARLY_RENEWAL_REDIRECT = 'index.customercare.customer.pricingPlanEarlyRenewal';
export var DBSS_PRODUCT_DETAILS_PAGE_REDIRECT = 'index.customercare.customer.dbss-products.redirect';
export var SUSPEND_SUBSCRIBER_PRODUCTS_REDIRECT = 'index.customercare.customer.suspendSubscriberProducts.redirect';
export var RESUME_SUBSCRIBER_PRODUCTS_REDIRECT = 'index.customercare.customer.restoreSubscriberProducts.redirect';
export var SUSPEND_SERVICES_REDIRECT = 'index.customercare.customer.suspendServices.redirect';
export var RESUME_SERVICES_REDIRECT = 'index.customercare.customer.resumeServices.redirect';
export var USAGE_DETAILS_NON_TELCO_SERVICES_REDIRECT = 'index.customercare.customer.nonTelcoUsageServices.redirect';
export var SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE = 'index.customercare.customer.serviceAddonsOrdering';
export var INVENTORY_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE = 'index.customercare.customer.inventoryAddonsOrdering';
export var PRODUCT_LIST_PAGE_REDIRECT = 'index.customercare.customer.customerProducts.list';
export var SERVICES_USAGE_PAGE_REDIRECT = 'index.customercare.customer.servicesAndUsage';
export var MAKE_PAYMENT_PAGE_REDIRECT = 'index.customercare.customer.makePayment';
export var CONFIGURE_AUTOPAY_PAGE_REDIRECT = 'index.customercare.customer.configureAutopay';
export var AUTOPAY_PAGE_REDIRECT = 'index.customercare.customer.autoPay';
export var TREATMENT_DETAILS_PAGE_REDIRECT = 'index.customercare.customer.treatmentDetails';
var MODIFY_FDO_ACTION_TYPE = 'modify-future-dated-order';
export function getReactRoutes(_ref) {
  var _objectSpread2;
  var isNonTelcoUsageServicePageEnabled = _ref.isNonTelcoUsageServicePageEnabled,
    isProductBetaEnabled = _ref.isProductBetaEnabled,
    isServicesAndUsageBetaEnabled = _ref.isServicesAndUsageBetaEnabled,
    isMakePaymentBetaEnabled = _ref.isMakePaymentBetaEnabled,
    isTreatmentBetaEnabled = _ref.isTreatmentBetaEnabled,
    isReactDashboardEnabled = _ref.isReactDashboardEnabled,
    isReactProductOrderEnabled = _ref.isReactProductOrderEnabled,
    isReactProfilePageEnabled = _ref.isReactProfilePageEnabled,
    isReactOrderHistoryEnabled = _ref.isReactOrderHistoryEnabled,
    isReactOrderDetailsEnabled = _ref.isReactOrderDetailsEnabled,
    isReactActionsPageEnabled = _ref.isReactActionsPageEnabled,
    isReactAutoPayEnabled = _ref.isReactAutoPayEnabled;
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, isReactDashboardEnabled ? _defineProperty({}, DASHBOARD_ROUTE, {
    url: "".concat(CUSTOMER, "/dashboard")
  }) : {}), {}, (_objectSpread2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, ACCOUNT_HIERARCHY_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/account-hierarchy")
  }), ACCOUNT_HIERARCHY_NODE_SERVICES_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/account-hierarchy/:hierarchyId/node/:hierarchyNodeSubscriberId/services")
  }), ADDRESSES_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/addresses")
  }), CASES_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/cases")
  }), CASES_DETAILS_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/cases/:caseId/details")
  }), E_WALLET_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/e-wallet")
  }), INVOICE_MESSAGES_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/billing/invoice-messages")
  }), INVENTORY_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/inventory")
  }), INVENTORY_DETAILS_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/inventory/:inventoryId")
  }), INTERACTIONS_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/interactions")
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, INTERACTIONS_DETAILS_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/interactions/:interactionId")
  }), RETRY_ACTIVATION_PAYMENT_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/retry-activation-payment"),
    queryBuilder: function queryBuilder(params) {
      return {
        transactionDetails: params.transactionDetailsForRetryPayment
      };
    }
  }), ADD_OFFERING_INSTANCES, {
    url: "".concat(CUSTOMER, "/ordering/add-offering-instances/"),
    queryBuilder: function queryBuilder(params) {
      var query = params.futureDatedOrderId ? {
        orderActionType: MODIFY_FDO_ACTION_TYPE,
        futureDatedOrderId: params.futureDatedOrderId,
        futureDatedOfferingId: params.futureDatedOfferingId
      } : {};
      if (params.pId) {
        query.pId = params.pId;
      }
      return query;
    }
  }), EDIT_OFFERING_INSTANCES, {
    url: "".concat(CUSTOMER, "/ordering/edit-offering-instances/:offeringId/:offeringInstanceId"),
    queryBuilder: function queryBuilder(params) {
      var query = params.futureDatedOrderId ? {
        orderActionType: MODIFY_FDO_ACTION_TYPE,
        futureDatedOrderId: params.futureDatedOrderId
      } : {};
      if (params.pId) {
        query.pId = params.pId;
      }
      return query;
    }
  }), REVIEW_SAVED_CART_INSTANCES, {
    url: "".concat(CUSTOMER, "/ordering/add-offering-instances?orderActionType=review-saved-cart")
  }), NEW_CONNECT_PAGE, {
    url: "".concat(HOME, "new-offering")
  }), GUEST_CHECKOUT, {
    url: "".concat(HOME, "new-offering?orderActionType=guest-checkout")
  }), ADD_OFFERING_PAGE, {
    url: "".concat(CUSTOMER, "/ordering/add-offering"),
    queryBuilder: function queryBuilder(params) {
      var query = params.futureDatedOrderId ? {
        orderActionType: MODIFY_FDO_ACTION_TYPE,
        futureDatedOrderId: params.futureDatedOrderId,
        futureDatedOfferingId: params.futureDatedOfferingId
      } : {};
      if (params.pId) {
        query.pId = params.pId;
      }
      return query;
    }
  }), REVIEW_SAVED_CART, {
    url: "".concat(CUSTOMER, "/ordering/add-offering?orderActionType=review-saved-cart")
  }), REVIEW_STORE_ORDER_ADD, {
    url: "".concat(CUSTOMER, "/ordering/add-offering/checkout/resume-store-order")
  }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, EDIT_OFFERING_PAGE, {
    url: "".concat(CUSTOMER, "/ordering/edit-offering/:offeringId/:offeringInstanceId"),
    queryBuilder: function queryBuilder(params) {
      var query = params.futureDatedOrderId ? {
        orderActionType: MODIFY_FDO_ACTION_TYPE,
        futureDatedOrderId: params.futureDatedOrderId
      } : {};
      if (params.pId) {
        query.pId = params.pId;
      }
      return query;
    }
  }), REVIEW_STORE_ORDER_EDIT, {
    url: "".concat(CUSTOMER, "/ordering/edit-offering/:offeringId/:offeringInstanceId/checkout/resume-store-order")
  }), REVIEW_STORE_ORDER_TRANSITION, {
    url: "".concat(CUSTOMER, "/ordering/change-offering/:offeringId/:offeringInstanceId/checkout/resume-store-order")
  }), CHANGE_OFFERING_PAGE, {
    url: "".concat(CUSTOMER, "/ordering/change-offering/:offeringId/:offeringInstanceId")
  }), DISCONNECT_OFFERS_DBSS_ROUTE, {
    url: "".concat(CUSTOMER, "/ordering/remove-offering/:offeringId/:offeringInstanceId")
  }), TRANSFER_STATE_NAME, {
    url: "".concat(CUSTOMER, "/ordering/transfer-offerings")
  }), NOTIFICATIONS_LIST_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/notifications")
  }), GROUP_ORDER_HISTORY_LIST_STATE_NAME, {
    url: "".concat(CUSTOMER, "/order-history/group-orders")
  })), isReactOrderHistoryEnabled ? _defineProperty({}, ORDER_HISTORY_LIST_STATE_NAME, {
    url: "".concat(CUSTOMER, "/order-history/orders")
  }) : {}), isReactOrderDetailsEnabled ? _defineProperty({}, ORDER_HISTORY_DETAILS_STATE_NAME, {
    url: "".concat(CUSTOMER, "/order-history/orders/:orderId")
  }) : {}), {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RATE_SHEET_STATE_REDIRECT, {
    url: "".concat(CUSTOMER, "/agreement")
  }), PRICING_PLAN_EARLY_RENEWAL_REDIRECT, {
    url: "".concat(ORDERING, "/plan/early-renewal/:offeringInstanceId/:subscriberProductId?")
  }), DBSS_PRODUCT_DETAILS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/products/details/:subscriberProductId")
  }), SUSPEND_SUBSCRIBER_PRODUCTS_REDIRECT, {
    url: "".concat(CUSTOMER, "/ordering/suspend-subscriber-products/:offeringId/:offeringInstanceId")
  }), RESUME_SUBSCRIBER_PRODUCTS_REDIRECT, {
    url: "".concat(CUSTOMER, "/ordering/restore-subscriber-products/:offeringId/:offeringInstanceId")
  }), SUSPEND_SERVICES_REDIRECT, {
    url: "".concat(CUSTOMER, "/ordering/suspend-services/:serviceIdentifier?")
  }), RESUME_SERVICES_REDIRECT, {
    url: "".concat(CUSTOMER, "/ordering/restore-services/:serviceIdentifier?")
  }), RECONNECT_OFFER_STATE_NAME, {
    url: "".concat(CUSTOMER, "/ordering/edit-offering/:offeringId/:offeringInstanceId/decisions/reconnect-offer-flow")
  }), DISCONNECT_CUSTOMER_DBSS_ROUTE, {
    url: "".concat(CUSTOMER, "/ordering/disconnect")
  }), E_WALLET_PAGE, {
    url: "".concat(CUSTOMER, "/e-wallet")
  }), isReactProfilePageEnabled ? _defineProperty({}, PROFILE_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/profile")
  }) : {}), isProductBetaEnabled ? _defineProperty({}, PRODUCT_LIST_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/products/list")
  }) : {}), isProductBetaEnabled ? _defineProperty({}, PRODUCT_DETAILS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/products/details/:lockerItemId")
  }) : {}), isTreatmentBetaEnabled ? _defineProperty({}, TREATMENT_DETAILS_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/treatment-details")
  }) : {}), {}, _defineProperty(_defineProperty({}, OFFERINGS_STATE_NAME, {
    url: "".concat(CUSTOMER, "/offerings/:offeringInstanceId?")
  }), SERVICE_DETAILS_STATE_NAME, {
    url: "".concat(SERVICES, "/:serviceIdentifier")
  }), isServicesAndUsageBetaEnabled ? _defineProperty(_defineProperty({}, SERVICES_USAGE_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/services-and-usages/services")
  }), SERVICE_USAGE_DETAILS_STATE_NAME, {
    url: "".concat(SERVICES_AND_USAGES, "/usage-details"),
    queryBuilder: function queryBuilder(params) {
      return {
        allEntitlements: params.allEntitlements,
        searchBy: params.searchBy,
        searchParams: JSON.stringify({
          UsageStatementId: params.statementId
        }),
        serviceAttributeId: params.serviceAttributeId,
        serviceIdentifierValue: params.serviceIdentifierValue,
        tab: params.tab
      };
    }
  }) : {}), isNonTelcoUsageServicePageEnabled ? _defineProperty({}, USAGE_DETAILS_NON_TELCO_SERVICES_REDIRECT, {
    url: "".concat(SERVICES_AND_USAGES, "/usage-details-finance"),
    queryBuilder: function queryBuilder(params) {
      return {
        serviceIdentifierValue: params.serviceIdentifierValue
      };
    }
  }) : {}), {}, _defineProperty(_defineProperty({}, SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, {
    url: "".concat(CUSTOMER, "/ordering/service-feature-products/:serviceIdentifierValue/:serviceId/service-add-ons/:serviceAttributeId")
  }), INVENTORY_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, {
    url: "".concat(CUSTOMER, "/ordering/service-feature-products/:serviceIdentifierValue/:serviceId/inventory-add-ons/:inventoryDisplayName")
  }), isMakePaymentBetaEnabled ? _defineProperty({}, MAKE_PAYMENT_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/make-payment/:account?"),
    params: function params(_params) {
      return _objectSpread(_objectSpread({}, _params !== null && _params !== void 0 && _params.account ? {
        account: _params === null || _params === void 0 ? void 0 : _params.account
      } : {}), {}, {
        customerId: _params === null || _params === void 0 ? void 0 : _params.customerId
      });
    },
    queryBuilder: function queryBuilder(params) {
      return _objectSpread(_objectSpread({}, params !== null && params !== void 0 && params.invoiceNumber ? {
        invoiceNumber: params.invoiceNumber
      } : {}), params.paymentType ? {
        paymentType: params.paymentType
      } : {});
    }
  }) : {}), isReactProductOrderEnabled ? _defineProperty({}, CREATE_PRODUCTS_ORDER_STATE_NAME, {
    url: "".concat(CUSTOMER, "/ordering/create-product-order")
  }) : {}), isReactActionsPageEnabled ? _defineProperty({}, ACTIONS_STATE_NAME, {
    url: "".concat(CUSTOMER, "/demo-actions")
  }) : {}), isReactAutoPayEnabled ? _defineProperty({}, AUTOPAY_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/configure-autopay")
  }) : {}), isReactAutoPayEnabled ? _defineProperty({}, CONFIGURE_AUTOPAY_PAGE_REDIRECT, {
    url: "".concat(CUSTOMER, "/configure-autopay")
  }) : {});
}
;